/* eslint-disable @next/next/no-img-element */
import GradientContainer from "../gradient/gradient-container"
import TextGradient from "../gradient/gradient-text"

interface SupportFeatureItemProps {
  icon: string,
  label: string,
}

interface SupportItemProps {
  description: string
}

const SupportFeatureItem = ({ icon, label }: SupportFeatureItemProps) => (
  <div className="bg-background-primary-dark-dark w-[105px] h-[100px] rounded-lg
  flex flex-col items-center justify-center space-y-2">
    <img src={`/assets/svgs/platform/${icon}.svg`} alt={`${label}`} />
    <label className="text-white label-md">{ label }</label>
  </div>
)

const SupportItem = ({ description }: SupportItemProps) => (
  <div className="flex items-center space-x-4">
    <GradientContainer overrideClassName="h-[44px] w-[4px]" />
    <p className="text-text-color-mid-em text-body-lg sm:text-body-xl-medium">
      {description}
    </p>
  </div>
)

const SupportFeatureItems = [
  {key: "01", icon: "phone-call", label: "Phone"},
  {key: "02", icon: "chat", label: "Chat"},
  {key: "03", icon: "share", label: "Screenshare"},
]

const SupportItems = [
  {key: "01", description:"Access live support"},
  {key: "02", description:"Prioritize your communications"},
  {key: "03", description:"Share rapid solutions"},
  {key: "04", description:"Elevate team experience"},
  {key: "05", description:"Boost software engagement"},
]

const Support = () => {
  return (
    <div className="py-20 px-10 lg:px-20 xl:px-[120px] xl-2:px-[160px]">
      <div className="sm:space-y-2">
        <TextGradient overrideClassName="italic subheading-xl-3 sm:h3">
          Support
        </TextGradient>
        <GradientContainer overrideClassName="w-full h-[4px] rounded" />
      </div>
      <div className="flex flex-col lg:flex-row lg:space-x-16">
        <div className="mt-10 space-y-6 lg:basis-1/2">
          <img
            className="rounded"
            src="/images/platform/support.png"
            alt="Support"
          />
          <h6 className="text-text-color-high-em text-center h6 sm:h5">LIVE help anytime you need it.</h6>
          <div className="flex justify-center space-x-2">
            {SupportFeatureItems.map((item) => (
              <SupportFeatureItem key={item.key} icon={item.icon} label={item.label} />
            ))}
          </div>
          <p className="text-text-color-high-em text-center text-body-md sm:text-body-lg">
            24/7 access to customer support through your preferred channel.
          </p>
        </div>
        <div className="space-y-10 mt-12 lg:basis-1/2">
          <div className="flex">
            <h6 className="text-base-dark h6 sm:h4 xl:h3">
              Discover the benefits of dedicated
              <span className="text-secondary-light">&nbsp;support.</span>
            </h6>
          </div>
          <div className="space-y-4">
            {SupportItems.map((item) => (
              <SupportItem key={item.key} description={item.description} />
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Support
